module.exports = __webpack_public_path__ + "static/media/descargarAma.282c486b.svg";